export default __webpack_public_path__ + "static/media/runablaze_2016.e1bfede1.png";